<template>
  <div class="pdfDownloadPage">
    <!-- 面包屑导航 -->
    <div class="breadcrumbBar">
      <div class="breadcrumbContent">
        <span class="breadcrumbLink" @click="goBack">服务支持</span>
        <span class="breadcrumbSeparator">></span>
        <span class="breadcrumbCurrent">{{ $t("Service.downloadTitle") }}</span>
      </div>
    </div>

    <div class="pdfContainer">
      <!-- 顶部分类标签 -->
      <div class="categoryTabs" v-if="!targetId">
        <div
          class="tabItem"
          v-for="item in getCategoryList"
          :class="{ active: currentCategory == item.id }"
          @click="selectCategory(item.id)"
        >
          {{ language === 'en' && item.fullNameEn ? item.fullNameEn : item.fullName }}
        </div>
      </div>

      <!-- 搜索框 -->
      <div class="searchBox" v-if="!targetId">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入您想搜索的操作手册"
          prefix-icon="el-icon-search"
          clearable
          @input="handleSearch"
        ></el-input>
      </div>

      <!-- 产品列表 -->
      <div class="productList" v-loading="loading">
        <div
          class="productCard"
          v-for="(product, index) in allProductList"
          :key="index"
        >
          <!-- 产品标题 -->
          <div class="productHeader">
            <div class="productIcon">
              <img v-if="product.icon" :src="product.icon" alt="" />
              <span v-else class="iconText">{{ product.iconText }}</span>
            </div>
            <div class="productTitle">{{ product.title }}</div>
          </div>

          <!-- PDF列表 -->
          <div class="pdfList">
            <div
              class="pdfItem"
              v-for="(pdf, pdfIndex) in product.pdfs"
              :key="pdfIndex"
              @click="downloadPdf(pdf)"
            >
              <div class="pdfInfo">
                <div class="pdfName">{{ pdf.name }}</div>
                <div class="pdfDate">{{ pdf.creatortime }}</div>
              </div>
              <div class="pdfIcon">
                <img
                  src="@/assets/image/pdf@3x.png"
                  alt="PDF"
                  v-if="hasPdfIcon"
                />
                <i
                  v-else
                  class="el-icon-document"
                  style="color: #f56c6c; font-size: 24px"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="emptyState" v-if="allProductList.length === 0 && !loading">
        <i class="el-icon-document"></i>
        <p>暂无相关手册</p>
      </div>

      <!-- 分页 -->
      <div class="paginationWrapper" v-if="total > pageSize">
        <el-pagination
          background
          layout="slot, prev, next, jumper"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handlePageChange"
        >
          <span class="pageInfo"
            >{{ currentPage }} / {{ totalPages || 1 }}</span
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { supportOptGuide, supportOptGuideInfo, supportOptGuideTree } from "@/assets/API/service";
import define from "@/utils/define";
const baceUrl = define.APIURl;
export default {
  name: "PdfDownloadPage",
  props: {
    targetId: { type: [String, Number], default: "" },
  },
  data() {
    return {
      language: this.$i18n.locale,
      searchKeyword: "",
      loading: false,
      currentCategory: "all",
      hasPdfIcon: false, // 是否有PDF图标图片

      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 所有产品数据
      allProductList: [],
      getCategoryList: [],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
  },
  mounted() {
    if (this.targetId) this.fetchTargetProduct();
    else this.fetchProductList();
    this.GetCategoryListFun();
  },
  methods: {
    mapProduct(item) {
      let pdfs = [];
      try {
        pdfs = typeof item.fileData === "string" ? JSON.parse(item.fileData || "[]") : (item.fileData || []);
      } catch (e) {
        pdfs = [];
      }
      return {
        id: item.id,
        title: this.language === "zh" ? item.title : (item.titleEn || item.title),
        icon: item.icon ? baceUrl + item.icon : "",
        iconText: (item.title || "PDF").split(" ").map(word => word[0]).join("").toUpperCase(),
        creatortime: item.creatortime,
        pdfs,
      };
    },
    async fetchTargetProduct() {
      this.loading = true;
      try {
        const res = await supportOptGuideInfo(this.targetId);
        if (res.code === 200 && res.data) {
          this.allProductList = [this.mapProduct(res.data)];
          this.total = 1;
        }
      } finally {
        this.loading = false;
      }
    },
    // 获取分类列表
    GetCategoryListFun() {
      supportOptGuideTree().then((res) => {
        if (res.code === 200) {
          this.getCategoryList = [
            { fullName: "全部", fullNameEn: "All", id: "all" },
            ...res.data.list[0].children.map((item) => ({
              fullName: item.fullName,
              fullNameEn: item.fullNameEn,
              id: item.id,
            })),
          ];
        }
      });
    },
    // 获取产品列表
    fetchProductList() {
      this.loading = true;
      supportOptGuide({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        typeId: this.currentCategory === "all" ? null : this.currentCategory,
        keyword: this.searchKeyword.trim() || null,
      }).then((res) => {
        if (res.code === 200) {
          const { records, total } = res.data;
          this.allProductList = records.map(this.mapProduct);
          console.log("产品列表接口返回：", this.allProductList);

          this.total = total;
        } else {
          this.$message.error("获取产品列表失败");
        }
        this.loading = false;
      });
    },

    // 选择分类
    selectCategory(category) {
      this.currentCategory = category;
      this.currentPage = 1;
      this.fetchProductList();
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.fetchProductList();
    },

    // 分页
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchProductList();
    },

    // 下载PDF
    downloadPdf(pdf) {
      if (pdf.url) {
        window.open(baceUrl + pdf.url, "_blank");
      } else {
        this.$message.info("暂无下载链接");
      }
    },

    // 返回
    goBack() {
      this.$emit("back");
    },
  },
};
</script>

<style scoped lang="scss">
.pdfDownloadPage {
  background: #f7f8fb;
  min-height: 100vh;
}

/* 面包屑导航 */
.breadcrumbBar {
  background: #333;
  padding: 16px 0;

  .breadcrumbContent {
    width: 1200px;
    margin: 0 auto;
    font-size: 14px;
    color: #fff;

    .breadcrumbLink {
      color: #aaa;
      cursor: pointer;

      &:hover {
        color: #fff;
      }
    }

    .breadcrumbSeparator {
      margin: 0 8px;
      color: #666;
    }

    .breadcrumbCurrent {
      color: #fff;
    }
  }
}

/* 主容器 */
.pdfContainer {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}

/* 分类标签 */
.categoryTabs {
  display: flex;
  justify-content: center;
  gap: 0;
  margin-bottom: 40px;
  background: #f0f0f0;
  border-radius: 30px;
  padding: 4px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;

  .tabItem {
    padding: 10px 32px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    border-radius: 26px;
    transition: all 0.3s;

    &:hover {
      color: #333;
    }

    &.active {
      background: #2b85e5;
      color: #fff;
    }
  }
}

/* 搜索框 */
.searchBox {
  margin-bottom: 30px;

  ::v-deep .el-input {
    width: 300px;

    .el-input__inner {
      border-radius: 4px;
      border-color: #ddd;

      &:focus {
        border-color: #2b85e5;
      }
    }
  }
}

/* 产品列表 */
.productList {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  min-height: 300px;
}

.productCard {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

  .productHeader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;

    .productIcon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #2b85e5 0%, #1a5fb4 100%);

      img {
        width: 100%;
        height: 100%;
        border-radius: 12px;
      }

      .iconText {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
      }
    }

    .productTitle {
      flex: 1;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
  }

  .pdfList {
    .pdfItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      background: #f9f9f9;
      border-radius: 8px;
      margin-bottom: 12px;
      cursor: pointer;
      transition: all 0.3s;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background: #f0f7ff;

        .pdfName {
          color: #2b85e5;
        }
      }

      .pdfInfo {
        flex: 1;

        .pdfName {
          font-size: 14px;
          color: #333;
          margin-bottom: 4px;
          transition: color 0.3s;
        }

        .pdfDate {
          font-size: 12px;
          color: #999;
        }
      }

      .pdfIcon {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}

/* 空状态 */
.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #999;

  i {
    font-size: 64px;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
  }
}

/* 分页 */
.paginationWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 40px;

  .pageInfo {
    font-size: 14px;
    color: #2b85e5;
    margin-right: 8px;
  }

  ::v-deep .el-pagination {
    padding: 0;

    .btn-prev,
    .btn-next {
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      min-width: 28px;
      height: 28px;

      &:hover:not(:disabled) {
        color: #2b85e5;
        border-color: #2b85e5;
      }
    }

    .el-pagination__jump {
      margin-left: 12px;
      font-size: 14px;

      .el-input {
        width: 50px;
        margin: 0 6px;

        .el-input__inner {
          height: 28px;
          text-align: center;
        }
      }
    }
  }
}
</style>
